import styled from "styled-components";

export const FindAccountTemplate = styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  background: ${(props) => props.theme.colors.mainBg};
  grid-template-rows: 56px auto;
`;

export const FindAccountContent = styled.section`
  gap: 35px;
  width: 100vw;
  height: calc(100vh - 56px);
  display: flex;
  overflow: auto;
  align-items: center;
  flex-direction: column;
`;
